export const COMMAND_ID = {
  entry: {
    read: "entry:read",
    readAbove: "entry:read-above",
    readBelow: "entry:read-below",
    viewSourceContent: "entry:view-source-content",
    readability: "entry:ability",
    openInBrowser: "entry:open-in-browser",
    star: "entry:star",
    toggleAITranslation: "entry:toggle-ai-translation",
    imageGallery: "entry:image-gallery",
    copyLink: "entry:copy-link",
    copyTitle: "entry:copy-title",
    tts: "entry:tts",
    exportAsPDF: "entry:export-as-pdf",
    delete: "entry:delete",
    share: "entry:share",
  },
  integration: {
    saveToEagle: "integration:save-to-eagle",
    saveToReadwise: "integration:save-to-readwise",
    saveToInstapaper: "integration:save-to-instapaper",
    saveToObsidian: "integration:save-to-obsidian",
    saveToOutline: "integration:save-to-outline",
    saveToReadeck: "integration:save-to-readeck",
    saveToCubox: "integration:save-to-cubox",
    saveToZotero: "integration:save-to-zotero",
    saveToQBittorrent: "integration:save-to-qbittorrent",

    custom: "integration:custom",
  },
  list: {
    edit: "list:edit",
    unfollow: "list:unfollow",
    navigateTo: "list:navigate-to",
    openInBrowser: "list:open-in-browser",
    copyUrl: "list:copy-url",
    copyId: "list:copy-id",
  },
  settings: {
    changeThemeToAuto: "follow:change-color-mode-to-auto",
    changeThemeToDark: "follow:change-color-mode-to-dark",
    changeThemeToLight: "follow:change-color-mode-to-light",
    customizeToolbar: "follow:customize-toolbar",
  },
  global: {
    showShortcuts: "global:show-shortcuts",
    toggleCornerPlay: "global:toggle-corner-play",
    quickAdd: "global:quick-add",
    toggleAIChat: "global:toggle-ai-chat",
    quickSearch: "global:quick-search",
  },
  layout: {
    toggleSubscriptionColumn: "layout:toggle-subscription-column",
    focusToTimeline: "layout:focus-to-timeline",
    focusToSubscription: "layout:focus-to-subscription",
    focusToEntryRender: "layout:focus-to-entry-render",
  },
  timeline: {
    switchToNext: "timeline:switch-to-next",
    switchToPrevious: "timeline:switch-to-previous",
    refetch: "timeline:refetch",
    unreadOnly: "timeline:unread-only",
  },
  entryRender: {
    scrollDown: "entry-render:scroll-down",
    scrollUp: "entry-render:scroll-up",
    nextEntry: "entry-render:next-entry",
    previousEntry: "entry-render:previous-entry",
  },
  subscription: {
    switchTabToNext: "subscription:switch-tab-to-next",
    switchTabToPrevious: "subscription:switch-tab-to-previous",
    switchTabToArticle: "subscription:switch-tab-to-article",
    switchTabToSocial: "subscription:switch-tab-to-social",
    switchTabToPicture: "subscription:switch-tab-to-picture",
    switchTabToVideo: "subscription:switch-tab-to-video",
    switchTabToAudio: "subscription:switch-tab-to-audio",
    switchTabToNotification: "subscription:switch-tab-to-notification",

    nextSubscription: "subscription:next",
    previousSubscription: "subscription:previous",

    toggleFolderCollapse: "subscription:toggle-folder-collapse",
    markAllAsRead: "subscription:mark-all-as-read",
    openInBrowser: "subscription:open-in-browser",
    openSiteInBrowser: "subscription:open-site-in-browser",
  },
} as const
